<template>
    <div :id="chartId" class="chart"></div>
</template>

<script>

    const imageStop =
        "data:image/png;base64,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"

    import * as echarts from 'echarts';
    export default {
        props:["name"],
        data(){
            return {
                chart:null,
                min:0,
                max:0,
                pointList:[]
            }
        },
        computed:{
            chartId(){
                return 'chart_'+this.name
            },
            markLine(){
                let data = []
                if(this.min){
                    data.push({yAxis: this.min, value:"最小值", label:{ formatter:()=>`最小值 ${this.min}` }})
                }
                if(this.max){
                    data.push({yAxis: this.max, value:"最大值", label:{ formatter:()=>`最大值 ${this.max}` }})
                }
                return {
                    symbol: "none",
                    lineStyle:{
                        color:"#666",
                        width:2,
                    },
                    data
                }
            }
        },
        mounted() {
            this.chart = echarts.init(document.getElementById(this.chartId));
            // this.setData([])
        },
        methods:{
            setData(pointList,min,max){
                this.pointList = pointList
                this.min = min
                this.max = max
                this.chart.setOption(this.createChartOption())
            },
            getMin(value){
                if(this.min){
                    value.min = Math.min(value.min,this.min)
                }
                if(value.max<1){
                    return (value.min / 1.05).toFixed(2)
                }else if(value.max<10){
                    return (value.min / 1.02).toFixed(2)
                }else{
                    return Math.floor(value.min / 1.01)
                }
            },
            getMax(value){
                if(this.max){
                    value.max = Math.max(value.max,this.max)
                }
                if(value.max<1){
                    return (value.max * 1.05).toFixed(2)
                }else if(value.max<10){
                    return (value.max * 1.02).toFixed(2)
                }else{
                    return Math.ceil(value.max * 1.01)
                }
            },
            getPointStyle(value){
                if(value[2]){
                    return {
                        label:"Q",
                        symbol:"pin",
                        symbolSize:[30,30]
                    }
                }else if(value[3]){
                    return {
                        label:"T",
                        symbol:"pin",
                        symbolSize:[30,30]
                    }
                }else{
                    return {
                        label:"",
                        symbol:"emptyCircle",
                        symbolSize:3
                    }
                }
            },
            createChartOption() {
                let self = this
                let data = []
                this.pointList.forEach(item=>{
                    data.push([item.date,item.value,item.start,item.stop])
                })
                let xAxisData = []
                let seriesData = []
                this.pointList.forEach(item=>{
                    xAxisData.push(item.date)
                    seriesData.push(item.value)
                })
                return {

                    title: {
                        text: this.name+"曲线",
                        // subtext: title,
                        left: "left",
                        padding: 20,
                        textStyle:{
                            fontSize:15,
                            fontWeight: "bold"
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        backgroundColor: 'rgba(245, 245, 245, 0.8)',
                        borderWidth: 1,
                        borderColor: '#ccc',
                        padding: 10,
                        textStyle: {
                            color: '#000'
                        },
//            position: function (pos, params, el, elRect, size) {
//              var obj = {top: 10};
//              obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
//              return obj;
//            },
                        extraCssText: 'width: 170px'
                    },
                    xAxis: {
                        type: 'time',
                        data: xAxisData,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {onZero: false},
                        min: 'dataMin',
                        max: 'dataMax',
                    },
                    yAxis: {
                        splitArea: {
                            show: true
                        },
                        axisLine: {onZero: false},
                        type: 'value',
                        // min: 'dataMin',
                        // max: 'dataMax',
                        min: this.getMin,
                        max: this.getMax
                    },
                    // dataZoom: [
                    //     {
                    //         type: 'inside',
                    //         start: 0,
                    //         end: 20
                    //     },
                    //     {
                    //         start: 0,
                    //         end: 20
                    //     }
                    // ],
                    series: [{
                        label: {
                            show:true,
                            position:"inside",
                            color:"#FFF",
                            fontSize: 10,
                            formatter(params){
                                return self.getPointStyle(params.value).label
                            },
                            fontWeight:"bold",
                        },
                        colorBy:"data",
                        data: data,
                        type: 'line',
                        smooth: true,
                        symbolSize(value,params){
                            return self.getPointStyle(params.value).symbolSize
                        },
                        symbol(value,params){
                            return self.getPointStyle(params.value).symbol
                        },
                        itemStyle: {
                            normal: {
                                color: '#2798F4',
                            }
                        },
                        lineStyle:{
                            width:1,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                            shadowBlur: 10,
                            shadowOffsetY:2
                        },
                        markPoint:{
                            symbol: "pin", //标注类型
                            symbolSize: [80,80] , //标记大小
                            itemStyle:{
                                fontSize:"10px",
                                textColor:"#FFF",
                                labelSize:"5px"
                            },
                            data:[
                                {coord:data[2][0], name: "最大值",value:"开始\n投药"},
                            ]
                        },
                        markLine:this.markLine,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgb(0,120,255,0.2)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgb(0,120,255,0.01)'
                                }
                            ])
                        },
                    }]
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.chart{
    width: 100%;
    height: 320px;
    border-bottom: 1px dashed #DDD;
}
</style>
